<template>
  <div class="row">
    <div class="col-md-12">
      <h4 class="required">Enter RA Remarks</h4>
      <el-select
          v-model="raRemarksModel"
          placeholder="Select"
          class="form-control form-control"
          id="remark"
          name="remark"
          :disabled="disabled"
      >
        <el-option
            v-for="item in raRemark"
            :key="item.value"
            :label="item.label"
            :value="item.value"
        ></el-option>
      </el-select>
      <el-input v-model="raTextRemarksModel"
                v-if="raRemarks === 'CF'"
                :maxlength="25"
                type="text"
                placeholder="RA Remarks"/>
      <p v-if="!$v.raRemarks.required || !$v.textRemarks.required" class="text-danger">
        Please enter remarks
      </p>
    </div>
  </div>
</template>

<script>
import {mapMutations, mapState} from 'vuex';
import {ORDER_RETURN_SET_REMARKS, ORDER_RETURN_SET_TEXT_REMARKS,} from '../../../store/modules/order/return/types';
import {RA_REMARK_CODES} from "../../../lang/en/constants";

export default {
  name: 'OrderReturnRemarks',
  inject: ['$v'],
  props: {
    disabled: {
      required: false,
      default: false,
      type: Boolean
    }
  },
  computed: {
    ...mapState({
      raRemarks: state => state.orderReturn.raRemarks,
      textRemarks: state => state.orderReturn.textRemarks,
    }),
    raRemarksModel: {
      get() {
        return this.raRemarks;
      },
      set(value) {
        this.setRemarks(value);
      },
    },
    raTextRemarksModel: {
      get() {
        return this.textRemarks;
      },
      set(value) {
        this.setTextRemarks(value);
      },
    },
  },
  methods: {
    ...mapMutations({
      setRemarks: ORDER_RETURN_SET_REMARKS,
      setTextRemarks: ORDER_RETURN_SET_TEXT_REMARKS,
    })
  },
  data() {
    return {
      raRemark: RA_REMARK_CODES
    };
  }
};
</script>
